export const theme = {
  config: {
    useBorderBox: false
  },
  breakpoints: ['480px', '760px', '980px', '1200px'],
  styles: {
    root: {
      fontSize: 18
    }
  }
}

export const widths = ['100vw', '100vw', '100vw', '940px', '1170px'];
